import React, { useEffect, useState } from "react";
import SideBar from "../master/SideBar";
import NavBar from "../master/NavBar";
import { LoadingDiv } from "../../pages/master/Master";
import { Link } from "react-router-dom";
import { AdminBranchList, AdminBranchStatusUpdate } from "../../api/AdminService";
import Swal from "sweetalert2";

export default function BranchList() {
    const [loading, setLoading] = useState("");
    const [branches, setBranches] = useState([]);

    const getBranches = async () => {
        try {
            setLoading(true);

            const response = await AdminBranchList();

            if (response.data.status) {
                setBranches(response.data.data || []);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const updateStatus = async (id, status) => {

        const result = await Swal.fire({
            title: "Change Status?",
            text: "Do you want to update this branch status?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
        });

        if (!result.isConfirmed) return;

        try {

            const response = await AdminBranchStatusUpdate({
                id,
                status,
            });

            if (response.data.status) {

                Swal.fire({
                    title: "Updated!",
                    text: response.data.message,
                    icon: "success",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                });

                getBranches();

            } else {

                Swal.fire({
                    title: "Warning!",
                    text: response.data.message,
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                });


            }

        } catch (error) {

            Swal.fire({
                title: "Error!",
                text: "Something went wrong.",
                icon: "error",
                confirmButtonText: "OK",
            });

            console.log(error);
        }
    };

    useEffect(() => {
        getBranches();
    }, []);

    return (
        <>
            {loading && <LoadingDiv />}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container ">
                    <SideBar />
                    <div className="layout-page">
                        <NavBar />
                        <div className="content-wrapper">
                            <div className="container-fluid p-4">
                                <div className="col-12">
                                    <div className="card p-3 mb-3 shadow-sm border-0">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center gap-3">
                                                <div
                                                    style={{
                                                        width: 45,
                                                        height: 45,
                                                        borderRadius: "12px",
                                                        background:
                                                            "linear-gradient(45deg,#185fa5,#4f8cff)",
                                                        color: "#fff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <i className="ri-building-4-line"></i>
                                                </div>

                                                <div>
                                                    <h5 className="m-0 fw-bold">
                                                        Branch Reports / Dashboard
                                                    </h5>
                                                    <small className="text-muted">
                                                        Branch performance, collection & analytics
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-center gap-2">



                                                <Link
                                                    to="/branch/add"
                                                    title="Add New Branch"
                                                    className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                                                    style={{ width: 40, height: 40 }}
                                                >
                                                    <i className="ri-add-line"></i>
                                                </Link>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="card shadow-sm border-0">
                                        <div className="card-header py-3">
                                            <h5 className="mb-0 fw-bold">
                                                Branch List
                                            </h5>
                                        </div>

                                        <div className="table-responsive">
                                            <table className="table table-hover align-middle mb-0">
                                                <thead className="">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Branch</th>
                                                        <th>Mobile</th>
                                                        <th>Email</th>
                                                        <th>Address</th>
                                                        <th>Last Active</th>
                                                        <th>Status</th>
                                                        <th>Action</th>

                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {branches?.length > 0 ? (
                                                        branches.map((branch, index) => (
                                                            <tr key={branch.id}>

                                                                <td>{index + 1}</td>

                                                                <td>
                                                                    <div>
                                                                        <div className="fw-bold">
                                                                            {branch.name}
                                                                        </div>

                                                                        <small className="text-muted">
                                                                            {branch.username}
                                                                        </small>
                                                                    </div>
                                                                </td>

                                                                <td>
                                                                    <span className="">
                                                                        {branch.mobile}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <span className="">
                                                                        {branch.email}
                                                                    </span>
                                                                </td>

                                                                <td>
                                                                    <span className="">
                                                                        {branch.address}
                                                                    </span>
                                                                </td>

                                                                <td className="">
                                                                    {branch.last_active}
                                                                </td>


                                                                <td>
                                                                    <div className="form-check form-switch">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="checkbox"
                                                                            checked={branch.status === "1"}
                                                                            onChange={() =>
                                                                                updateStatus(
                                                                                    branch.id,
                                                                                    branch.status === "1" ? "2" : "1"
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="d-flex gap-1">

                                                                        <Link
                                                                            to={`/branch/add?id=${branch.id}`}
                                                                            className=" btn-sm "
                                                                            title="Update Branch"
                                                                        >
                                                                            <i className="ri-edit-line"></i>
                                                                        </Link>

                                                                    </div>
                                                                </td>


                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="10" className="text-center py-4">
                                                                No Branch Found
                                                            </td>
                                                        </tr>
                                                    )}

                                                </tbody>
                                            </table>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}
